// extracted by mini-css-extract-plugin
module.exports = {"stickyHeader":"MasterTable_stickyHeader_3xQJn","q-table__top":"MasterTable_q-table__top_Uqvvd","q-table__bottom":"MasterTable_q-table__bottom_1RYgy"};